import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { Link as ReachLink } from '@reach/router';
import { upperFirst } from 'lodash';

import TokenStore from 'js/stores/pages/AdminDashboardPage/TokenStore';
import { formatCurrency } from 'js/services/Format';
import { adminPanelColor } from 'js/config/style';

import LoadingSpinner from '../../LoadingSpinner';
import DashPanel from '../../DashPanel';
import Header from '../../DashPanel/Header';
import Content from '../../DashPanel/Content';
import DropMenu from '../../DashPanel/DropMenu';

import Link from './Link';
import Icon from './Icon';
import Title from './Title';
import Text from './Text';

import Card from './Card';
import Display from './Display';
import Image from './Image';
import Details from './Details';
import Label from './Label';
import Price from './Price';

import Row from '../../List/Row';
import User from '../../Display/User';
import Order from '../../Display/Order';
import List from "js/components/pages/AdminDashboardPage/List";
import ListItem from "js/components/pages/AdminDashboardPage/List/ListItem";
import LinkUsage from "js/components/pages/AdminDashboardPage/Items/Item/LinkUsage";
import ListMessage from "js/components/pages/AdminDashboardPage/List/ListMessage";

@observer
export default class Token extends Component {
  token = TokenStore.create({ alias: this.props['*'] });

  constructor(props) {
    super(props);
    this.token.load();
  }

  render() {
    const token = this.token;
    return (
      <DashPanel>
        <Header>
          <DropMenu />
          <Title>
            <Link to="/admin/tokens">Tokens</Link>
            {token.title && (
              <>
                <Icon name="chevron-right" />
                <Text>{token.title}</Text>
              </>
            )}
          </Title>
        </Header>

        <Provider model={token}>
          <Content background={adminPanelColor}>
            {this.token.isLoading ? (
              <LoadingSpinner />
            ) : (
              <>
                <Card>
                  <Display>
                    <Image src={token.image} />
                  </Display>

                  <Details>
                    <Label>Created</Label>
                    <div>{token.created_at}</div>

                    <Label>Item</Label>
                    <div>
                      {token.title} {token.size && `(${upperFirst(token.size)})`}
                    </div>

                    {token.item_address ? (
                      <>
                        <Label>Address</Label>
                        <div>{token.item_address}</div>
                      </>
                    ) : null}

                    <Label>Status</Label>
                    <div>{token.human_status}</div>

                    <Label>Price</Label>
                    <div>
                      <Price>{formatCurrency(token.price)}</Price>
                    </div>
                  </Details>
                </Card>

                <div>
                  <Row cols={2}>
                    <User load={{ email: token.buyer_email }} title="Buyer (token creator)" />
                    <User load={{ email: token.seller_email }} title="Seller" />
                  </Row>

                  <Row cols={2}>
                    <Order load={{ alias: token.alias }} title="Order" />
                  </Row>

                  <Row>
                    <List paginator={token.item_usage_logs} title="Link usage" icon="file-text">
                      <div>
                        {token.item_usage_logs.length ? (
                          token.item_usage_logs.map((log, index) => (
                            <ListItem key={index} to={log.user_email ? `/admin/users/user/${log.user_email}` : null}>
                              <LinkUsage log={log} />
                            </ListItem>
                          ))
                        ) : (
                          <ListMessage>Not used so far</ListMessage>
                        )}
                      </div>
                    </List>
                  </Row>

                </div>
              </>
            )}
          </Content>
        </Provider>
      </DashPanel>
    );
  }
}
